import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* LEFT */}
        <div className="footer-brand">
          <h2>
            Shirdhankar <span>Technologies</span>
          </h2>

          <p>
            Building digital experiences that power the future. Web, Mobile,
            Software & Game Development.
          </p>

          <div className="footer-socials"></div>
        </div>

        {/* COMPANY */}
        <div className="footer-column">
          <h4>Company</h4>

          <ul>
            <li><Link to="/">About</Link></li>
            <li><Link to="/">Industries</Link></li>
            <li><Link to="/">Contact</Link></li>
          </ul>
        </div>

        {/* SERVICES */}
        <div className="footer-column">
          <h4>Services</h4>

          <ul>
            <li>
              <Link to="/services/web-development">
                Web Development
              </Link>
            </li>

            <li>
              <Link to="/services/mobile-app-development">
                App Development
              </Link>
            </li>

            <li>
              <Link to="/services/software-development">
                Software Development
              </Link>
            </li>

            <li>
              <Link to="/services/game-development">
                Game Development
              </Link>
            </li>
          </ul>
        </div>

        {/* RESOURCES */}
        <div className="footer-column">
          <h4>Resources</h4>

          <ul>
            <li>
              <Link to="/blog">
                Blog
              </Link>
            </li>
          </ul>
        </div>

      </div>

      <div className="footer-bottom">
        © 2026 Shirdhankar Technologies. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;